export default __webpack_public_path__ + "static/media/team-male-placeholder.44f980ed.png";